/*
 * Module for the MemberDirect Enrollment and Usage Criteria page
 */
rs.module("content/reports/memberdirectenrollmentandusagecriteria",

    ["common/select-helper"],

    function (selectHelper) {

        function initialize(jsSelectors) {

            var criteria = $.js(jsSelectors.criteria);

            var detailCheckbox = criteria.js(jsSelectors.detailCheckbox);
            var sortSelect = criteria.js(jsSelectors.sortSelect);

            // Get Select Helper for sortSelect since we're updating its options and properties
            var sortSelectHelper = selectHelper.getHelper(sortSelect);

            // disable the detail dropdown based on the status of 
            detailCheckbox.change(function () {
                if (detailCheckbox.is(":checked")) {
                    sortSelectHelper.setDisabled(false);
                }
                else {
                    sortSelectHelper.setDisabled(true);
                }
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);